import * as React from "react";
import { GridWrapper } from "../../integrations/UoE-Grid/GridWrapper";
import { Logging } from "../../Logging";
import "../../assets/css/AOS2/AOS2_Agent_Access_Page.css";
import "../../assets/css/AOS2/AOS2_Visualisation.css";
import { useApi } from "../../Providers/ApiProvider";
import LineChart2 from "./Visualisation/LineChart2";

export default function AOS2_ADMIN_Agent_Single_Stats() {
  let api = useApi();
  let [data, setData] = React.useState();
  let [YearStartInput, setYearStartInput] = React.useState<number>(2022);
  let [YearEndInput, setYearEndInput] = React.useState<number>(2025);
  let [AgentDomAcct, setAgentDomAcct] = React.useState<string>("");
  let [valid, setValid] = React.useState<boolean>(false);
  let [UGdata, setUGdata] = React.useState([]);
  let [PGdata, setPGdata] = React.useState([]);
  let [TotalData, setTotalData] = React.useState([]);
  let [selector, setSelector] = React.useState([]);
  let [widthGraph, setWidthGraph] = React.useState<number>(928);
  let [heightGraph, setHeightGraph] = React.useState<number>(500);

  // check for valid years
  React.useEffect(() => {
    setValid(YearEndInput >= YearStartInput);
  }, [YearStartInput, YearEndInput]);

  // handle window resize for width/height of graph
  (React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth - 100 < 928) {
        const gWidth = window.innerWidth * 0.85;
        setWidthGraph(gWidth);
      } else {
        setWidthGraph(928);
      }
    }
    window.addEventListener("resize", handleResize);
  }),
    [widthGraph]);

  //console.log('resize:', window.innerWidth, 'x', window.innerHeight)
  //console.log('resized W value:', widthGraph);
  //console.log('e resized W value:', widthGraph);

  // call sproc and setup up data for insertion to graph
  React.useEffect(() => {
    api.General.get(
      "/sproc",
      JSON.stringify({
        sproc: "sputilities.webui.AOSv2_ADMIN_AgentStatsSingle",
        params: [
          "@StartYear4",
          YearStartInput.toString(),
          "@EndYear4",
          YearEndInput.toString(),
          "@AgentDomainAccount",
          AgentDomAcct.toString(),
        ],
      }),
    )
      .then((respData) => {
        // setData(respData);
        // console.log(respData);

        setUGdata([]);
        setPGdata([]);
        setTotalData([]);

        for (const [key, value] of Object.entries(respData[0][0])) {
          // console.log(`${key}: ${value}`);
          if (key.startsWith("UG")) {
            setUGdata((old) => {
              old.push({
                label: new Date(key.replace("UG_", "")),
                val: value,
              });
              return [...old];
            });
          } else if (key.startsWith("PG")) {
            setPGdata((old) => {
              old.push({
                label: new Date(key.replace("PG_", "")),
                val: value,
              });
              return [...old];
            });
          } else if (key.startsWith("Total")) {
            setTotalData((old) => {
              old.push({
                label: new Date(key.replace("Total_", "")),
                val: value,
              });
              return [...old];
            });
          }
        }
      })
      .catch((rejects) => {
        setUGdata([]);
        setPGdata([]);
        setTotalData([]);
      });
  }, [YearStartInput, YearEndInput, AgentDomAcct]);

  return (
    <div className="Agent_Single_Stats">
      <h2>Agent Statistics</h2>
      <p>
        Enter the required start year and finish year, as long as it is a valid
        range the data will automatically populate.
      </p>
      <p></p>
      <div className="RequestRow">
        <label className="inputLabel" htmlFor="AgentDom">
          Agent Domain Account:{" "}
        </label>
        <input
          className="AgentDomInput"
          id="AgentDomInput"
          type="string"
          //pattern = /^([a|A][g|G][t|T]+[0-9]{4})$/
          value={AgentDomAcct}
          onChange={(e) => {
            setAgentDomAcct(e.target.value);
            // console.log(e.target.value);
          }}
        />
      </div>
      <div className="JustASpacer"></div>
      <div className="RequestRow">
        <label className="inputLabel" htmlFor="YearStart">
          Start Year:{" "}
        </label>
        <input
          className="YearStartInput"
          id="YearStartInput"
          type="number"
          min="2006"
          // max="2030"
          //autoComplete="2024"
          value={YearStartInput}
          maxLength={4}
          onChange={(e) => {
            setYearStartInput(e.target.valueAsNumber);
            // setYearEndInput(e.target.valueAsNumber);
            // console.log(e.target.value);
          }}
        />
      </div>
      <div className="JustASpacer"></div>
      <div className="RequestRow">
        <label className="inputLabel" htmlFor="YearEnd">
          End Year:{" "}
        </label>
        <input
          className="YearEndInput"
          id="YearEndInput"
          type="number"
          min="2007"
          value={YearEndInput}
          maxLength={4}
          onChange={(e) => {
            setYearEndInput(e.target.valueAsNumber);
            // console.log(e.target.value);
          }}
        />
      </div>

      {valid && (
        <>
          <div className="JustASpacer"></div>
          <div className="RequestRow">
            {/* <input
                id="submit"
                type="button"
                value="Search"
                onClick={() => {
                    setYearStartInput(YearStartInput);
                    setYearEndInput(YearEndInput);
                    setAgentDomAcct(AgentDomAcct);
                }}
                /> */}
          </div>

          <div className="JustASpacer"></div>
          <div className="JustASpacer"></div>
          <div className="MainPageData">
            <GridWrapper
              eid={"Agent_Single_Stats"}
              sproc="sputilities.webui.AOSv2_ADMIN_AgentStatsSingle"
              params={[
                "@StartYear4",
                YearStartInput.toString(),
                "@EndYear4",
                YearEndInput.toString(),
                "@AgentDomainAccount",
                AgentDomAcct.toString(),
              ]}
              Callouts={false}
              URLParams={""}
            ></GridWrapper>
          </div>
        </>
      )}
      <div className="JustASpacer"></div>
      {/* <select value={selector} onChange={setSelector(e.target.value)}>
                <option value={"UGChart"}>UG</option>
                <option value={"PGChart"}>PG</option>
                <option value={"TotalChart"}>Total</option>
            </select> */}

      <div className="JustASpacer"></div>
      <div className="Chart">
        <h3>UG Applicants by year</h3>
        {/* <LineChart width={800} height={400} data={UGdata} /> */}
        <LineChart2 data={UGdata} width={widthGraph} />
      </div>
      <div className="JustASpacer"></div>
      <div className="Chart">
        <h3>PG Applicants by year</h3>
        {/* <LineChart width={800} height={400} data={PGdata} /> */}
        <LineChart2 data={PGdata} width={widthGraph} />
      </div>
      <div className="JustASpacer"></div>
      <div className="Chart">
        <h3>Total Applicants by year</h3>
        {/* <LineChart width={800} height={400} data={TotalData} /> */}
        <LineChart2 data={TotalData} width={widthGraph} />
      </div>
    </div>
  );
}
